export const tableTitle = ['Id', 'Email', 'Прізвище', 'Ім’я',  'По батькові', 'Посада', 'Роль', 'Відділення', ''];

export const filterDate = [
    {name: 'id', placeholder: 'Пошук за id'},
    {name: 'email', placeholder: 'Пошук за Email'},
    {name: 'surname', placeholder: 'Пошук за прізвищем'},
    {name: 'name', placeholder: "Пошук за ім'ям"},
    {name: 'patronymic', placeholder: 'Пошук за ім’ям по батькові'},
    {name: 'position', placeholder: 'Пошук за посадою'},
    {name: 'roleLabel', type: 'select', options: [{name:'Усі', value: ''}, {name:'Адміністратор', value: 'admin'}, {name:'Медичний директор', value: 'medicalDirector'}, {name:'Реєстратор медичний', value: 'registrar'}, {name:'Лаборант', value: 'laboratoryAssistant'}, {name:'Помічник лаборанта', value: 'assistant'}, {name:'Лікар-патологоанатом', value: 'doctorPathologist'}, {name:'Лікар-патологоанатом дитячий', value: 'doctorPathologistChild'}], placeholder: 'Пошук за роллю'},
    {name: 'department', placeholder: 'Пошук за відділенням'},
];

export const searchOptions = [
    {value: "id", name: "за ID", type: "text"},
    {value: "email", name: "за EMAIL", type: "text"},
    {value: "role", name: "за роллю", type: "text"},
    {value: "position", name: "за посадою", type: "text"},
    {value: "surname", name: "за прізвищем", type: "text"},
    {value: "name", name: "за іменем пацієнта", type: "text"},
    {value: "patronymic", name: "за по батькові", type: "text"},
    {value: "department", name: "за відділенням", type: "text"}
];